import { useContext } from "react";
import { AxiosContext } from "../Utils/axiosUtil";
const useAuth = () => {
  const context = useContext(AxiosContext);

  if (!context) {
    throw new Error("useAuth must be used inside AxiosProvider");
  }

  return context.auth;
};

export default useAuth;